import * as React from 'react';
import { TbInfoCircle } from 'react-icons/tb';

import clsxm from '@/utils/clsxm';

import { Tooltip } from '@/components/atoms/Tooltip';
import { FontWeight } from '@/components/atoms/Typography/interface';

type InputGroupLabelProps = {
  id: string;
  label: string;
  required?: boolean;
  tooltipMessage?: string;
  preventFocusOnLabelClick?: boolean;
  weight?: FontWeight;
};

export const InputGroupLabel = ({ label, id, required, tooltipMessage, preventFocusOnLabelClick = false, weight = 'regular' }: InputGroupLabelProps) => {
  let inputLabel: string | React.ReactNode = label;
  if (required) {
    inputLabel = (
      <>
        {inputLabel} <div className="bg-red-500 h-2.5 w-1 rounded-[20px]" />
      </>
    );
  }
  if (tooltipMessage) {
    inputLabel = (
      <div className="flex items-center gap-1">
        {inputLabel}
        <Tooltip content={tooltipMessage}>
          <TbInfoCircle />
        </Tooltip>
      </div>
    );
  }
  return (
    <label
      htmlFor={!preventFocusOnLabelClick ? id : undefined}
      className={clsxm('flex gap-2 items-center text-base text-slate-700 ', [
        weight === 'regular' && 'font-normal',
        weight === 'medium' && 'font-medium',
        weight === 'semibold' && 'font-semibold',
        weight === 'bold' && 'font-bold',
        weight === 'extrabold' && 'font-extrabold'
      ])}
    >
      {inputLabel}
    </label>
  );
};
